/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';
import { FiscalCode } from './fiscalCode';
import { IdentityDocument } from './identityDocument';


export interface TransferCustomer { 
    address?: Address;
    authorityDelivery?: string;
    code?: string;
    countryNationality?: string;
    dateCreation?: Date;
    dateModified?: Date;
    dateOfBirth?: Date;
    email?: string;
    firstName?: string;
    fiscalCode?: FiscalCode;
    gender?: TransferCustomer.GenderEnum;
    idBirthCity?: number;
    idCorpCityDelivery?: number;
    idDocument?: IdentityDocument;
    idExistentCustomerIdentityDocument?: number;
    lastName?: string;
    mobile?: string;
    occupation?: string;
    sellerCode?: string;
    telephone?: string;
    userCreatedBy?: string;
    userModifiedBy?: string;
}
export namespace TransferCustomer {
    export type GenderEnum = 'Male' | 'Female';
    export const GenderEnum = {
        Male: 'Male' as GenderEnum,
        Female: 'Female' as GenderEnum
    };
}
